import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MoveToGroupIcon } from '@components/icons/svg-icon.tsx';
import { DevicesExtraButtonsProps } from '@modules/digital-signage/model/devices.model.ts';

const DevicesExtraButtons: React.FC<DevicesExtraButtonsProps> = ({
  selectedRows,
  onMoveToGroup
}) => {
  const { t } = useTranslation();

  if (!selectedRows.length) return null;

  return (
    <Button
      className="h-8.5 min-w-25! px-3! text-[12px] bg-(--gray-11)! border-(--gray-6)! text-(--dark-alpha-600)!"
      variant="outlined"
      startIcon={<MoveToGroupIcon className="w-4! h-4!" />}
      onClick={onMoveToGroup}
    >
      {t('move_to_group')}
    </Button>
  );
};

export default DevicesExtraButtons;
